import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.33341 0.333252H2.00008C1.26675 0.333252 0.666748 0.933252 0.666748 1.66659V12.3333C0.666748 13.0666 1.26008 13.6666 1.99341 13.6666H10.0001C10.7334 13.6666 11.3334 13.0666 11.3334 12.3333V4.33325L7.33341 0.333252ZM8.66675 6.99992H3.33341V8.33325H8.66675V6.99992ZM8.66675 9.66659H3.33341V10.9999H8.66675V9.66659ZM2.00008 12.3333H10.0001V4.99992H6.66675V1.66659H2.00008V12.3333Z",
		fill: "#757783"
	})]
});
const ForwardRef = forwardRef(SvgIcFile);
export default ForwardRef;
